import React from 'react'
import {useHistory} from 'react-router'
import {ElectionLogo} from '../../elements/ElectionLogo'
import iltalehti from '../../../images/iltalehti_logo.svg'
import './LogoutPage.scss'

const LogoutPage = () => {
  const history = useHistory()

  const handleLogin = async () => {
    const dataString = sessionStorage.getItem('dataString')
    const url = `/kirjaudu/${dataString}`
    history.push(url)
  }

  return (
    <div className="logout-page">
      <div className="logout-page__il-logo">
        <img src={iltalehti} />
      </div>
      <ElectionLogo />
      <div className="logout-page__container">
        <div className="logout-page__container-text">Olet kirjautunut ulos</div>
        <button onClick={handleLogin} className="logout-page__container-button">
          Kirjaudu uudelleen
        </button>
      </div>
    </div>
  )
}

export default LogoutPage
